module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("HOW TO MAKE COLLABORATION WORK")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/0001.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("Powerful Ways to Build Consensus, Solve Problems, and Make Decisions")]), _c('br'), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("DAVID STRAUS")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/0002.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3295799a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 60
// module chunks = 0